import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class MyGrievanceService {
  constructor(public httpClient: HttpClient) { }

  //load mhada user grievance rest
  async loadGrievanceForInternalUser() {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadGrievanceForMhadaUser, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //
}
